export const mushroomIdle = new Image();
mushroomIdle.src = "assets/characterSprites/mushroom/Idle.png";
mushroomIdle.width = 1200/8;
mushroomIdle.height = 150/1;
mushroomIdle.yOffset = 38
mushroomIdle.xOffset = 150
mushroomIdle.cycleLoop = [0, 0, 1, 1, 2, 2, 3, 3];